/**
 * The slugs that `/main/<hospital>/<app>` actually resolves to a screen.
 *
 * Kept in its own module, rather than inside Apps.tsx, so analytics can check a
 * slug without importing every app component. Both sides read this list: if a
 * name is here, `appMap` in Apps.tsx must have an entry for it (TypeScript
 * enforces that), and analytics will record a visit to it.
 *
 * Anything not on the list renders "app not found", so it must NOT be recorded
 * as a visit — otherwise a typo'd or retired link becomes a row in the stats
 * table labelled with the raw slug.
 */
export const APP_NAMES = [
  'eos',
  'phototherapy',
  'bili2022',
  'qtc-calculator',
  'triage',
  'resus',
  'resus-nursing',
  'correctedAge',
  'test-tubes',
  'egfr',
  'preemie-nutrition',
  'nicu-nutrition',
  'asthma',
  'antibiogram',
  'new-preemie',
  'sepsis-screening',
  'hematological-diseases',
] as const;

export type AppName = (typeof APP_NAMES)[number];

const KNOWN = new Set<string>(APP_NAMES);

export const isKnownAppName = (value: string | null | undefined): value is AppName =>
  typeof value === 'string' && KNOWN.has(value);
